import { PhoneNumber } from '@/types/TphoneNumber';
import { PayloadAction, Slice, createSlice } from '@reduxjs/toolkit';

const initialState: PhoneNumber = {
	phoneNumber: null,
};

export const slice: Slice<
	PhoneNumber,
	{
		setPhoneNumber: (state: PhoneNumber, action: PayloadAction<{ phoneNumber: string }>) => void;
	}
> = createSlice({
	name: 'phoneNumber',
	initialState,
	reducers: {
		setPhoneNumber: (state, action) => {
			state.phoneNumber = action.payload.phoneNumber;
		},
	},
});

export const { setPhoneNumber } = slice.actions;

export default slice.reducer;
